import classNames from "classnames";
import * as React from "react";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Hyperlink from "../../Link/Hyperlink";
import Render from "../../Render";
import { StyleClass } from "../../Styles/CSS";
import { dynamicOpacityFormClass, sharedFormStyleClass } from "../Form";
import * as formStyles from "../Form.css";
import { IFormInputOptions } from "./IFormInputOptions";

export function FormInput({
    id,
    label,
    width,
    minWidth,
    maxWidth,
    type,
    classes,
    placeholder,
    suggestions,
    value,
    onChange,
    onClear,
    onEnter,
    onFocus,
    onDefocus,
    pattern,
    ref,
    inputMode,
    autocomplete,
    showEnterHint = true,
    readonly = false,
    displayBlock = false,
    dynamicOpacity = false,
}: IFormInputOptions) {
    return (
        <span
            className={classNames(formStyles.main, {
                [formStyles.hidden]: readonly,
                [formStyles.displayBlock]: displayBlock,
            })}
        >
            <Render id="label" when={label !== undefined}>
                <span className={formStyles.label}>{label}</span>
            </Render>
            <input
                id={id}
                type={type}
                style={{ width, minWidth, maxWidth }}
                className={classNames(
                    [formStyles.formControl],
                    sharedFormStyleClass,
                    { [dynamicOpacityFormClass]: dynamicOpacity },
                    classes
                )}
                placeholder={placeholder}
                list={suggestions ? `datalist_${id}` : ""}
                value={value}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onDefocus}
                pattern={pattern ? pattern : "."}
                ref={ref}
                readOnly={readonly}
                onKeyPress={async (event) => {
                    if (event.key === "Enter" && onEnter) {
                        onEnter();
                    }
                }}
                inputMode={inputMode ? inputMode : "text"}
                autoComplete={autocomplete}
            />
            <datalist id={`datalist_${id}`}>
                {suggestions
                    ? suggestions.map((item, index) => (
                          <option value={item} key={index} />
                      ))
                    : null}
            </datalist>
            <Render
                id="clearInputIcon"
                when={onClear !== undefined}
                withClasses={StyleClass(`formInputClearIconContainer`, {
                    position: `relative`,
                })}
            >
                <Hyperlink
                    classes={formStyles.clearInput}
                    whenClicked={() => (onClear ? onClear() : {})}
                >
                    <Glyphicon icon={EGlyphicon["remove"]} />
                </Hyperlink>
            </Render>
            <Render
                id="pressEnterLabel"
                when={showEnterHint && onEnter && value}
                withClasses={formStyles.pressEnterLabelFormInput}
            >
                ↵
            </Render>
        </span>
    );
}
